var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconArrowGray16(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_393_2757)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 11.3333C6.91226 11.3338 6.82529 11.317 6.74406 11.2838C6.66284 11.2507 6.58896 11.2018 6.52667 11.14C6.46418 11.078 6.41459 11.0043 6.38074 10.923C6.34689 10.8418 6.32947 10.7547 6.32947 10.6667C6.32947 10.5787 6.34689 10.4915 6.38074 10.4103C6.41459 10.329 6.46418 10.2553 6.52667 10.1933L8.73333 7.99999L6.61333 5.79333C6.48917 5.66842 6.41947 5.49945 6.41947 5.32333C6.41947 5.1472 6.48917 4.97824 6.61333 4.85333C6.67531 4.79084 6.74904 4.74124 6.83028 4.7074C6.91152 4.67355 6.99866 4.65613 7.08667 4.65613C7.17467 4.65613 7.26181 4.67355 7.34305 4.7074C7.42429 4.74124 7.49802 4.79084 7.56 4.85333L10.1333 7.51999C10.2555 7.64461 10.3239 7.81216 10.3239 7.98666C10.3239 8.16116 10.2555 8.32871 10.1333 8.45333L7.46667 11.12C7.40683 11.1846 7.33478 11.2367 7.25468 11.2734C7.17458 11.31 7.08802 11.3304 7 11.3333Z",
    fill: "#70737C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_393_2757"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowGray16);
export default __webpack_public_path__ + "static/media/icon_arrow_gray_16.d0ffb4161d75fbef29d491ff00023dda.svg";
export { ForwardRef as ReactComponent };